module.exports = __webpack_public_path__ + "static/1-22601dd3a1a469e255fa15c2815bebbf.jpg";